<template>
  <div>
      <v-tabs
        :value="currentTabIndex"
        @change="changeTab"
        background-color="transparent"
        class="bg-white mb-5 rounded"
      >
        <v-tab
          v-for="tabItem in tabs"
          :tabindex="tabItem.index"
          :key="tabItem.index"
          @click="loadRoute(tabItem.routeName)"
          >{{ tabItem.label }}</v-tab
        >
      </v-tabs>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("REGISTER_INFO"),
          routeName: "registerInfomation",
          roles: []
        },
        {
          index: 1,
          label: this.$t("EXTENSION"),
          routeName: "hotelAmenities",
          roles: ['HOTEL_AMENITY']
        },
        {
          index: 2,
          label: this.$t("IMAGES"),
          routeName: "hotelImages",
          roles: ['HOTEL_IMAGE']
        },
        {
          index: 3,
          label: this.$t("NEARBY_PLACE"),
          routeName: "nearby",
          roles: ['NEARBY_PLACE']
        }
      ]
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    switch (this.$route.name) {
      case "registerInfomation":
        this.currentTabIndex = 0;
        break;
      case "hotelAmenities":
        this.currentTabIndex = 1;
        break;
      case "hotelImages":
        this.currentTabIndex = 2;
        break;
      case "nearby":
        this.currentTabIndex = 3;
        break;
    }
  },
  watch: {},
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
